import { Effect, all } from "redux-saga/effects"
import { Injector } from "../../di/Injector"
import { watchGetEventDetails } from "./sagas/watchGetEventDetails"
import { watchGetEvents } from "./sagas/watchGetEvents"

export function* events(injector: Injector): Generator<Effect> {
  yield all([watchGetEvents(injector), watchGetEventDetails(injector)])
}
